import {Controller} from "@/controllers/Controller";

/**
 * Controller for settings API (ms-marketing) : réglages marketing du groupe
 */
export class SettingsController extends Controller {

    // Objectif de répartition, consigne de rédaction, modèle de rédaction par défaut
    static get() {
        return this.requestBuilder("GET", `/marketing/settings`, true);
    }

    static patch(body) {
        return this.requestBuilder("PATCH", `/marketing/settings`, true, body);
    }
}
